import { Outlet } from 'react-router-dom';

import { BreadCrumb } from '@/components/breadcrumb/breadcrumb';
import { AppSidebar } from '@/components/sidebar/appSidebar';
import { SidebarInset } from '@/components/ui/sidebar';
import { useGame } from '@/hooks/useGame';
import type { DashboardItem } from '@/models/dashboardItem';

interface DashboardProps {
  items?: DashboardItem[];
  menu: boolean;
}

const Dashboard = (props: DashboardProps) => {
  const game = useGame();

  return (
    <>
      <AppSidebar
        items={props.items?.filter((item) => !item.disabled)}
        selectGame={props.menu}
        selectedGame={game}
       />
      <SidebarInset>
        <main className="flex-1">
          <BreadCrumb />
          <div className="layout">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </>
  );
};

export default Dashboard;
